import { useEffect, useRef } from 'react'

import type { IWebGlRender, UpdateValue } from '../../../types'
import { requestRedraw } from '../../../utils'

const compareArrays = (renderA: IWebGlRender[], renderB: IWebGlRender[]) =>
  renderA.length === renderB.length && renderA.every((element, index) => element === renderB[index])

export const useCheckRenders = (renders: IWebGlRender[], setUpdate: UpdateValue<number>) => {
  const previousRendersRef = useRef<IWebGlRender[]>([])
  useEffect(() => {
    if (!compareArrays(renders, previousRendersRef.current) && renders.length !== 0) {
      previousRendersRef.current = [...renders]
      requestRedraw(setUpdate)
    }
  })
}
